import React, { type ReactNode } from 'react';
import type { Props } from '@theme/Icon/Close';
import { IconClose as IconCloseRx } from '@site/src/components/icons/close';

export default function IconClose(_props: Props): ReactNode {
  return <IconCloseRx clickable />;
}
